import React, { useEffect } from 'react';

import css from './HomePageListingsList.module.css';
import { ListingCard, NamedLink, IconSpinner } from '../../components';
import { searchListings } from '../../ducks/homepage.duck';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getListingsById } from '../../ducks/marketplaceData.duck';
import { isOriginInUse } from '../../util/search';
import { useConfiguration } from '../../context/configurationContext';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { FormattedMessage } from '../../util/reactIntl';

const SearchLink = () => {
  return (
    <NamedLink name="SearchPage" className={css.searchLinkMaybe}>
      <span className={css.searchLinkLabel}>
        <FormattedMessage id="HomePageListingsList.search" />
      </span>
    </NamedLink>
  );
};

/**
 * Listings list on home page
 *
 * @component
 * @param {Object} props
 * @param {Array<propTypes.listing|propTypes.ownListing>} props.listings - The listings
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @returns {JSX.Element} ListingsList
 */

const HomePageListingsListComponent = props => {
  const { listings, onManageDisableScrolling, onSearchListings, searchInProgress } = props;

  const config = useConfiguration();

  useEffect(() => {
    let queryParams = {};

    // if (isTrainee) {
    //   queryParams.pub_listingType = `has_any:daily,hourly,fixed`;
    // } else {
    //   queryParams.pub_listingType = 'free_inquiry';
    // }

    // queryParams.pub_listingType = `has_any:daily,hourly,fixed`;

    const { page = 1, address, origin, ...rest } = queryParams;

    const originMaybe = isOriginInUse(config) && origin ? { origin } : {};
    const {
      aspectWidth = 1,
      aspectHeight = 1,
      variantPrefix = 'listing-card',
    } = config.layout.listingImage;
    const aspectRatio = aspectHeight / aspectWidth;
    const searchParams = {
      ...rest,
      ...originMaybe,
      page: 1,
      perPage: 12,
      include: ['author', 'images'],
      'fields.listing': [
        'title',
        'geolocation',
        'price',
        'deleted',
        'state',
        'publicData',
        'publicData.listingType',
        'publicData.transactionProcessAlias',
        'publicData.unitType',
        // These help rendering of 'purchase' listings,
        // when transitioning from search page to listing page
        'publicData.pickupEnabled',
        'publicData.shippingEnabled',
      ],
      'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
      'fields.image': [
        'variants.scaled-small',
        'variants.scaled-medium',
        `variants.${variantPrefix}`,
        `variants.${variantPrefix}-2x`,
      ],
      ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
      ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
      'limit.images': 1,
    };

    onSearchListings(searchParams, config);
  }, []);

  return (
    <>
      {searchInProgress && (
        <div className={css.listingsSpinner}>
          {<IconSpinner />}
        </div>
      )}
      {!!listings?.length && (
        <ul className={css.listings}>
          {listings.map((l, i) => (
            <li className={css.item} key={l.id.uuid}>
              <ListingCard
                onManageDisableScrolling={onManageDisableScrolling}
                listing={l}
                showAuthorInfo={false}
                isRedirect={true}
              />
            </li>
          ))}
        </ul>
      )}

      {/*<SearchLink />*/}
    </>
  );
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  const { currentPageResultIds, isTrainerSearch, isTraineeSearch, searchInProgress } = state.homepage;

  const listings = getListingsById(state, currentPageResultIds);

  return {
    listings,
    isTrainerSearch,
    isTraineeSearch,
    currentUser,
    searchInProgress
  };
};

const mapDispatchToProps = dispatch => ({
  onSearchListings: (params, config) => dispatch(searchListings(params, config)),
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const HomePageListingsList = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl
)(HomePageListingsListComponent);

export default HomePageListingsList;
